import React from 'react'
import { List, ListItem, ListItemButton, ListItemText } from '@mui/material'
import { themePalette } from '../themePalette'

/* eslint-disable react/prop-types */
const DropdownList = ({ title, items, navigate, location, rol }) => {
  return (
    <List component="div" disablePadding>
      {items
        ?.filter((subItem) => subItem.rol.includes(rol))
        .map((subItem, index) => (
          <ListItem
            key={`sub-${title}-${index}`}
            disablePadding
            onClick={() => navigate(subItem.path)}
            sx={{
              bgcolor: location.pathname === subItem.path ? '#eeeeee' : 'transparent',
              ':hover': { bgcolor: themePalette.defaultHoverSidebar }
            }}
          >
            <ListItemButton sx={{ pl: 9 }}>
              <ListItemText primary={subItem.title} />
            </ListItemButton>
          </ListItem>
        ))}
    </List>
  )
}

export default DropdownList
